export default function clamp(min, n, max) {
  return Math.max(min, Math.min(max, n));
}
